import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CellComponent, CellContext, GridData } from '@grid/models';

@Component({
  selector: 'app-mandatory-text',
  templateUrl: './mandatory-text.component.html',
  styleUrls: ['./mandatory-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MandatoryTextComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;
}
